
<ng-container *ngIf="codigoControle == 'PENDENTE'">

  <div class="alert alert-warning" role="alert">
    A consulta poderá levar até 7 minutos para retornar. Favor atualizar a página periodicamente até o carregamento da consulta.
  </div>
</ng-container>
<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg" [token]="token">



  <ng-container *ngIf="consulta">

    <h2 class="subtitle text-uppercase">Dados</h2>
    <ul class="card-list-striped">
      <li><span class="text-secondary">Placa </span><span>{{consulta?.placa || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Chassi </span><span>{{consulta?.chassi || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Tipo Veículo </span><span>{{consulta?.tipoVeiculo || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Ano Modelo </span><span>{{consulta?.anoModelo || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Ano Fabricação </span><span>{{consulta?.anoFabricacao || 'NÃO INFORMADO'}}</span>
      <li><span class="text-secondary">Modelo </span><span>{{consulta?.modelo || 'NÃO INFORMADO'}}</span></li>
      <li><span class="text-secondary">Marca </span><span>{{consulta?.marca || 'NÃO INFORMADO'}}</span></li>
    </ul>
    <h2 class="subtitle text-uppercase">Cotações</h2>
    <div class="table-responsive">
      <table class="table table-striped table-sm w-100 text-center">
        <thead class="fw-500 text-primary text-center">
          <th>Seguradoras</th>
          <th>Status</th>
        </thead>
        <tbody>
          <tr *ngFor="let i of consulta?.lista">
            <td class="text-uppercase">{{i?.seguradora || "NADA CONSTA"}}</td>
            <td class="text-uppercase">{{i?.aceitacao || "NÃO INFORMADO"}}</td>
          </tr>
        </tbody>
      </table>
      <div style="margin: 10px 40px 10px 0; text-align: center">
        <ul class="f-14">
          <li class="text-secondary format-compacta" style="list-style: none; font-size: 0.8em;">
            Esta simulação foi realizada com base nas características gerais do veículo. Não considera apontamentos físicos, outras restrições ou dados cadastrais do cliente junto a seguradora, ficando a critério da mesma a sua aceitação ou não.
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</app-card-consulta>
